export const ADDRESS_LOOKUP_COPY = {
    // Verbatim from design §8 — do not reword without changing the design.
    unavailable: 'Address lookup unavailable, please enter manually',
    throttled: 'Too many address searches. Please wait a moment, or enter the address manually.',
    noMatches: 'No matches — enter the address manually.',
    minChars: (n: number) => `Type at least ${n} character${n === 1 ? '' : 's'} to search.`,
    searching: 'Searching…',
    filled: 'Address filled in below. Check the fields and edit if needed.',
    // Fallback accessible name for a consumer that omits `id` (so there is no
    // `<label htmlFor>` to supply one).
    ariaLabel: 'Find address',
} as const;
